import React, { useCallback, useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import materialApi from "./libs/api/material";
import Error from "./erros/Error";
import MaterialGenerator from "./pages/teacher_material/MaterialGenerator";
import MaterialRunner from "./pages/teacher_material/MaterialRunner";
import { Inspection } from "./components/Inspection/Inspection";
import { isLocalHosted,baseUrl, EditMaterialUrl, CustomMaterialUrl } from "./libs/env";
import PreviewMaterial from "./pages/teacher_material/PreviewMaterial";

export const getMaterialId = () => {
    let id;
    if (window.location.pathname.split("/").length === 4) {
      id = window.location.pathname.split("/")[3];
    } else {
      id = window.location.pathname.split("/")[2];
    }
    return id;
  };

const MaterialApp = (props) => {
  let MaterialPath = `/material/:id`;
  let CreateMaterialPath = `/material/generate/:id`;
  let EditMaterialPath = `/material/edit/:id`;
  let MaterialTempPath = `/material/template/:id`;
  const [items, setItems] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);
  const [IsGenerating, setIsGenerating] = useState(false);
  const [ShowSocketData, setShowSocketData] = useState();

  const setSocketCallback = useCallback((isValue) => {
    setShowSocketData(isValue)
  },[]);
  if (isLocalHosted === false) {
    Inspection();
  }

useEffect(() => {
  if (window.location.pathname.includes(CustomMaterialUrl))
  { 
    materialApi
    .getformdata()
    .then((res) => res.json())
    .then((json) => {
      setItems(json);
    })
    .catch((error) => console.log(error.message));
  }
  else{
    materialApi
    .get({ id: getMaterialId() })
    .then((res) => res.json())
    .then((json) => {
    setIsLoaded(true);
    setItems(json);
    })
    .catch((error) => console.log(error.message));
  }

},[]);
  const GenerateMaterial = (formData) => {
    setIsGenerating(true);
    materialApi
      .postformdata({ data: formData })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          // window.location.replace(`${baseUrl}/genai${GenaiUrl}${json.exercise_id}`);
        }
        else
        {
          setIsGenerating(false)
        }
      });
  };
  const CreateMaterial = (data) => {
    const createdData = {is_create: true , data: data}
    materialApi
      .postformdata({ data: createdData })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          window.location.replace(`${baseUrl}${EditMaterialUrl}/${json.material_id}`);
        }
        else{
          console.error(json);
        }
      });
  };
  const UpdateMaterial = (data) => {
      const updatedData = {is_edit: true , materialdata: data}
      // setIsSubmitting(true);
      materialApi
        .post({ id: getMaterialId(), data: updatedData })
        .then((res) => res.json())
        .then((json) => {
          console.log(json);
        });
  };

  return (
    <>
    <Switch>   
        <Route exact path={CreateMaterialPath}>
          <MaterialGenerator
            GenerateMaterial={GenerateMaterial}
            data={items}
            isLoaded={isLoaded}
            IsGenerating={IsGenerating}
            setIsGenerating={setIsGenerating}
            CreateMaterial={CreateMaterial}
            setShowSocketData={setSocketCallback}
            ShowSocketData={ShowSocketData}
          />
        </Route>
        <Route exact path={EditMaterialPath}>
          <MaterialGenerator
            GenerateMaterial={GenerateMaterial}
            data={items}
            isLoaded={isLoaded}
            IsGenerating={IsGenerating}
            setIsGenerating={setIsGenerating}
            CreateMaterial={CreateMaterial}
            setShowSocketData={setSocketCallback}
            ShowSocketData={ShowSocketData}
            UpdateMaterial={UpdateMaterial}
          />
        </Route>
        <Route exact path={MaterialTempPath}>
          <PreviewMaterial
            data={items}
            isLoaded={isLoaded}
          />
        </Route>
        <Route exact path={MaterialPath}>
          {items.detail ? (
            <Error data={items} isLoaded={isLoaded} />
          ) : (
            <MaterialRunner
              data={items}
              isLoaded={isLoaded}
            />
          )}
        </Route>
    </Switch>
    </>
  );
};

export default MaterialApp;
